import initSmoothScroll from "./scripts/smoothScroll";
import initCustomCursor from "./scripts/customCursor";
import initMagneticHover from "./scripts/magneticHover";
import initRoleTyping from "./scripts/roleTyping";
import initHeroCanvas from "./scripts/heroCanvas";
import {
  initHeroAnimations,
  initScrollAnimations,
  initParallaxThumbnails,
  initTerminalReveal,
  initNavScroll,
} from "./scripts/gsapAnimations";

document.addEventListener("DOMContentLoaded", () => {
  initSmoothScroll();
  initHeroCanvas();
  initCustomCursor();
  initMagneticHover();
  initRoleTyping();
  initHeroAnimations();
  initScrollAnimations();
  initParallaxThumbnails();
  initTerminalReveal();
  initNavScroll();
});
